import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = 'https://staff.praxisamring-hameln.de';

// Get auth token from localStorage or cookies
const getAuthToken = () => {
  return (
    localStorage.getItem('authToken') ||
    Cookies.get('jwtToken') ||
    null
  );
};

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Authorization': `Bearer ${getAuthToken()}`,
    'Content-Type': 'application/json',
  },
});

// Contact Information service methods
export const contactInfoService = {
  // Get contact information
  getContactInfo: async () => {
    try {
      console.log('[contactInfoService] GET /info/contact', {
        url: `${API_BASE_URL}/info/contact`
      });
      const response = await axios.get(`${API_BASE_URL}/info/contact`);
      return response.data;
    } catch (error) {
      console.error('Error fetching contact information:', error);
      throw error;
    }
  },

  // Get formatted contact information
  getFormattedContactInfo: async () => {
    try {
      console.log('[contactInfoService] GET /info/contact/formatted', {
        url: `${API_BASE_URL}/info/contact/formatted`
      });
      const response = await axios.get(`${API_BASE_URL}/info/contact/formatted`);
      return response.data;
    } catch (error) {
      console.error('Error fetching formatted contact information:', error);
      throw error;
    }
  },

  // Update complete contact information
  updateContactInfo: async (contactData) => {
    try {
      console.log('[contactInfoService] PUT /info/contact', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/info/contact`,
        data: contactData
      });
      
      const response = await axios.put(`${API_BASE_URL}/info/contact`, contactData, {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating contact information:', error);
      throw error;
    }
  },

  // Update specific field of contact information
  updateContactField: async (field, value) => {
    try {
      const fieldData = { field, value };
      
      console.log('[contactInfoService] PATCH /info/contact/field', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/info/contact/field`,
        data: fieldData
      });
      
      const response = await axios.patch(`${API_BASE_URL}/info/contact/field`, fieldData, {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating contact field:', error);
      throw error;
    }
  },
};
